import Minze, { MinzeElement, Reactive, EventListeners } from 'minze'
import { MODALS } from '../../constants'
import MainModule from '../../modules/main'
import { Routing } from '../../modules/routing'
import { Locale } from '../../modules/locale'
import { AdditionalTypes } from '../../modules/additionalTypes'
import { Font } from '../../constants'
import { Callback } from '../../modules/callback'

Locale.getInstance().registerKeySet('fr', 'profileCultureMain', {
  description:
    'Indiquez vos intérêts culturels pour personnaliser votre expérience sur La Vitrine!',
  pickFavouritesLabel: 'Choisissez vos activités favorites!',
  seeSubCategories: 'Voir les sous-catégories',
  changeSavedMsg: 'Vos préférences ont été enregistrées avec succès!',
})

Locale.getInstance().registerKeySet('en', 'profileCultureMain', {
  description: 'Share your cultural interests to personalize your experience on La Vitrine!',
  pickFavouritesLabel: 'Choose your favourite activities!',
  seeSubCategories: 'See subcategories',
  changeSavedMsg: 'Your preferences have been saved successfully!',
})

export interface LvcProfileCultureModalContent {
  userSelection: { [key: string]: string[] }
  selectedCategories: string[]
}

export class LvcProfileCultureModalContent extends MinzeElement {
  private toggleCb: string = Callback.attach(this.onToggleMainCategory.bind(this))
  reactive: Reactive = [['userSelection', {}]]
  categories: any[] = []
  subCategoriesByCategory: any = {}
  listSubCategories: any[] = []
  async updateUserSelection(): Promise<void> {
    const mainModule = MainModule.getInstance()

    const userData = mainModule.getAuth().getUserData()
    if (userData?.profile?.culturalProfile) {
      this.userSelection = userData.profile?.culturalProfile
    } else {
      this.userSelection = {}
    }

    this.rerender()
  }

  async onReady(): Promise<void> {
    const mainModule = MainModule.getInstance()

    this.categories = await AdditionalTypes.getInstance().getCategories()
    // for (let category of this.categories) {
    //   this.subCategoriesByCategory[category.code] =
    //     await AdditionalTypes.getInstance().getSubCategoriesBySlug(
    //       category.code,
    //     );
    // }

    const userData = mainModule.getAuth().getUserData()

    if (userData?.profile?.culturalProfile) {
      this.selectedCategories = userData.profile?.culturalProfile
    }

    if (!this.selectedCategories) {
      this.selectedCategories = []
    }

    this.rerender()

    this.listSubCategories = await AdditionalTypes.getInstance().getAll()
    await this.updateUserSelection()
  }

  openCategoryScreen = (event: Event) => {
    const eventCard = (event.target as Element)?.closest('.category-btn') as Element | null
    const categoryData = this.categories.find(category => category.code === eventCard?.id)
    if (!categoryData) return
    this.cast('category-selected', categoryData)
  }

  goBack = () => {
    const mainModule = MainModule.getInstance()
    const routing = mainModule.getRouting()
    const lang = mainModule.getLang()

    routing.goTo(Routing.ROUTES[lang].profileCulture)
  }

  async onToggleMainCategory(toggledState: boolean, categoryId: string): Promise<void> {
    this.saveCategory(toggledState, categoryId)
  }

  saveCategory = async (toggledState: boolean, categoryId: string) => {
    const mainModule = MainModule.getInstance()

    // If the toggled state is false, remove the categoryId from the userSelection
    if (!toggledState) {
      // Remove entire category from userSelection
      this.userSelection[categoryId] = []
    } else {
      // if the toggled state is true
      // Add the categoryId to the userSelection if it's not already there
      if (!this.userSelection[categoryId]) {
        this.userSelection[categoryId] = [categoryId]
      } else if (!this.userSelection[categoryId].includes(categoryId)) {
        this.userSelection[categoryId].push(categoryId)
      }

      // Select all subcategories in the category array
      // const subCategories = this.subCategoriesByCategory[categoryId];
      // if (subCategories) {
      //   subCategories.forEach((subCategory: any) => {
      //     if (!this.userSelection[categoryId].includes(subCategory.code)) {
      //       this.userSelection[categoryId].push(subCategory.code);
      //     }
      //   });
      // }
    }

    // Save the userSelection with a delay to prevent spamming
    clearTimeout(this.saveTimeout as NodeJS.Timeout)
    this.saveTimeout = setTimeout(async () => {
      await mainModule.getAuth().saveProfile(`profile-culture`, this.userSelection)
      mainModule.showToastAlert(Locale.getKey('profileCultureMain.changeSavedMsg'))
    }, 1000)

    this.rerender()
  }

  renderSelections = async () => {
    return `

    `
  }

  private renderChips = (category: any) => {
    let userSelectionHasCategory = this.userSelection?.[category.code]
    let userSelectionCategory = userSelectionHasCategory ? this.userSelection?.[category.code] : []

    if (userSelectionCategory.length === 0) {
      return ``
    }

    let returnString =
      userSelectionCategory
        ?.slice(0, 2)
        .map((selectedSubCategoryCode: string) => {
          if (selectedSubCategoryCode.includes(category.code)) {
            return ''
          }
          return `
          <lvc-chip
              theme="dark"
              width="fit-content"
              class="category-chip"
              selected="true"
          >
              ${
                this.listSubCategories.find(item => {
                  return item.code === selectedSubCategoryCode
                })?.label ?? ''
              }
          </lvc-chip>
      `
        })
        .join('') ?? ''

    let selectedCategoriesCount = userSelectionCategory?.length

    return `
      ${returnString}
      ${selectedCategoriesCount > 2 ? `<div class="selection-more-label">+${selectedCategoriesCount - 2}</div>` : ''}
      `
  }

  private renderCategory(category: any) {
    let { code, label } = category

    // check if user has selected any subcategories for this category
    let userSelectionHasCategory = this?.userSelection?.[category.code]?.length > 0 || false

    // get subcategories for this category
    // const subCategories = this.subCategoriesByCategory[code];

    return `
        <lvc-box class="category-container" display="flex" alignItems="flex-start" justifyContent="space-between" height="auto">
            <lvc-box width="100%" textAlign="left" class="left-side-container" display="flex" flexDirection="column">
              <lvc-box>
                <span class="category-label">${label}</span>
              </lvc-box>
            </lvc-box>
            <lvc-box width="100%" display="flex" flexDirection="column" alignItems="flex-end">
                <lvc-toggle id=${code} class="toggle" on-click="${this.toggleCb}" initial-toggled="${userSelectionHasCategory}"></lvc-toggle>
            </lvc-box>
        </lvc-box>
    `
  }

  html = () => `
    <div class="form">
      <lvc-box mt="8px">
        <lvc-text font-preset="small">${Locale.getKey('profileCultureMain.description')}</lvc-text>
        <lvc-box mt="24px">
          ${this.categories.map(category => this.renderCategory(category)).join('')}
        </lvc-box>
        <lvc-box mt="24px" display="flex" width="100%" columnGap="16px" class="button-wrapper">
        </lvc-box>
      </lvc-box>
    </div>
  `

  css = () => `
    :host {

    }

    .category-container{
      padding: 16px;
      margin-bottom: 16px;
      border-bottom: 1px solid #90B2A1;
    }

    .left-side-container{
      gap: 8px;
    }

    .category-btn{
      font-size: 14px;
      font-style: normal;
      font-weight: ${Font.weight.medium};
      line-height: 21px;
      color: var(--Minuit, #1E007D);
      text-decoration: underline;
      }

    .category-label {
      font-weight: ${Font.weight.extraBold};
      font-size: 20px;
      line-height: 120%;
      text-transform: uppercase;
      color: #1E007D;
    }

    lvc-chevron-right-icon {
      width: 24px;
      height: 24px;
    }

    .selection-more-label {
      font-weight: ${Font.weight.bold};
      font-size: 16px;
      line-height: 120%;
    }
  `

  eventListeners: EventListeners = [
    ['.category-btn', 'click', this.openCategoryScreen.bind(this)],
    ['#btn-back', 'click', this.goBack.bind(this)],
    [window, 'lvc:user_state_changed', this.updateUserSelection.bind(this)],
  ]
}
